import { Component, OnInit, input, output } from "@angular/core";
import { IFilterSelection } from "../../../../core-ui/models/interfaces";

@Component({
  selector: "av-filter-item",
  templateUrl: "./filter-item.component.html",
  styleUrls: ["./filter-item.component.scss"],
  standalone: false,
})
export class FilterItemComponent implements OnInit {
  readonly value = input<any>(undefined);
  readonly disabled = input<boolean>(undefined);
  readonly checked = input<boolean>(undefined);
  readonly type = input<"checkbox" | "radio">("checkbox");
  /** groups radio items, so that the browser handles arrow-key navigation */
  readonly name = input<string>(undefined);

  readonly changed = output<IFilterSelection<any>>();

  constructor() {}

  ngOnInit(): void {}

  change(event: CustomEvent<HTMLInputElement>) {
    this.changed.emit({
      checked: (event.target as HTMLInputElement).checked,
      value: this.value(),
    });
  }
}
